<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { Tag } from '@/types/api/api-v3/product'
import { TagSize } from '@/types/products'

defineProps({
  tag: {
    type: Object as PropType<Tag>,
    required: true,
  },
  size: {
    type: String as PropType<TagSize>,
    required: false,
    default: String(TagSize.NORMAL),
  },
})

const onError = (error: Event) => {
  if (!error.target) {
    return
  }

  const target = error.target as HTMLElement

  target.style.display = 'none'
}
</script>

<template>
  <nuxt-img
    v-if="tag.image"
    class="tag"
    :class="{ 'size--large': size === TagSize.LARGE }"
    :src="tag.image"
    :alt="tag.name"
    @error="onError"
  />
</template>

<style lang="scss" scoped>
.tag {
  width: 14px;
  height: 14px;
  object-fit: cover;
  border-radius: 50%;
  @include media('>=tablet') {
    width: 20px;
    height: 20px;
  }
}

.size--large {
  width: 24px;
  height: 24px;
}
</style>
